import { render, staticRenderFns } from "./DistributorsView.vue?vue&type=template&id=6fe908f7&scoped=true&"
import script from "./DistributorsView.vue?vue&type=script&lang=js&"
export * from "./DistributorsView.vue?vue&type=script&lang=js&"
import style0 from "./DistributorsView.vue?vue&type=style&index=0&id=6fe908f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe908f7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCol,VDivider,VIcon,VRow})
